import customFetch from "../helpers/customFetch";
import { API_URL, getConfigExactian } from "../helpers/helpers";

export const checkAccessService = async (EMPLOYEE_ID, openingCode, buildingId) => {
    try {
        const configs = getConfigExactian('GET')
        const response = await customFetch(`${API_URL}access/checked/${EMPLOYEE_ID}?openingCode=${openingCode}&buildingId=${buildingId}`, configs);
        if (!response.ok) {
            return {
                ok: false,
                data: response
            }
        } else {
            const resData = await response.json();
            return {
                ok: true,
                data: resData
            }
        }
    } catch (e) {
        return console.log(e);
    }
}

export const getAccessContractorsService = async (EMPLOYEE_ID, openingCode, buildingId) => {
    try {
        const configs = getConfigExactian('GET')
        const response = await customFetch(`${API_URL}access/unchecked/${EMPLOYEE_ID}?openingCode=${openingCode}&buildingId=${buildingId}`, configs);
        if (!response.ok) {
            return {
                ok: false,
                data: response
            }
        } else {
            const resData = await response.json();
            return {
                ok: true,
                data: resData
            }
        }
    } catch (e) {
        return console.log(e);
    }
}

export const confirmAccessService = async (value) => {
    try {
        const configs = getConfigExactian('POST', value)
        const response = await customFetch(`${API_URL}access/in`, configs);
        if (!response.ok) {
            return {
                ok: false,
                data: response
            }
        } else {
            const resData = await response.json();
            return {
                ok: true,
                data: resData
            }
        }
    } catch (e) {
        return console.log(e);
    }
}

export const confirmExitService = async (value) => {
    try {
        const configs = getConfigExactian('POST', value)
        const response = await customFetch(`${API_URL}access/out`, configs);
        if (!response.ok) {
            return {
                ok: false,
                data: response
            }
        } else {
            const resData = await response.json();
            return {
                ok: true,
                data: resData
            }
        }
    } catch (e) {
        return console.log(e);
    }
}